import { useQuery } from '@apollo/client';

import { VOUCHERS } from '../graphql/query/vouchersQuery.graphql';

export const useVouchersQuery = (eventId: string | null) => {
  return useQuery(VOUCHERS, {
    variables: { eventId: eventId ?? '' },
    skip: !eventId,
  });
};
